<template>
  <div class="compatibility-backdrop" @click.stop>
    <section class="compatibility-notice" role="dialog" aria-modal="true" aria-labelledby="compatibility-title" aria-describedby="compatibility-content" @keydown.tab.prevent="$refs.confirm.focus()">
      <h2 id="compatibility-title">温馨提示</h2>
      <p id="compatibility-content">{{ content }}</p>
      <button ref="confirm" type="button" @click="$emit('close')">知道了</button>
    </section>
  </div>
</template>
<script>
export default {
  props: { content: { type: String, required: true } },
  mounted() { this.$nextTick(() => this.$refs.confirm.focus()) }
}
</script>
<style scoped>
.compatibility-backdrop { position: fixed; inset: 0; z-index: 100; background: rgba(0,0,0,.3); display: flex; align-items: center; justify-content: center; padding: 16px; box-sizing: border-box; }
.compatibility-notice { width: 320px; max-width: 100%; max-height: calc(100vh - 32px); overflow: auto; border-radius: 12px; background: #fff; color: #333; text-align: center; }
h2 { font-size: 18px; margin: 24px 24px 14px; }
p { font-size: 14px; line-height: 1.6; margin: 0 24px 24px; overflow-wrap: anywhere; }
button { width: 100%; min-height: 48px; border: 0; border-top: 1px solid #eee; background: transparent; color: var(--primary-color); font-size: 16px; cursor: pointer; }
button:focus-visible { outline: 2px solid var(--primary-color); outline-offset: -3px; }
</style>
